export default __webpack_public_path__ + "projects.0af19701e10db84797a6f3969b1c74b5.jpg"